/**
 * Module-scoped allocator used to specify the allocator for Typed Array's that are allocated by this
 * library
 * @module
 */
import type { Alloc } from "./alloc";
import { HeapAlloc } from "./alloc";

/**
 * This allocator is used to allocate TypedArray-based geometry (eg PolyLine2/3). By default,
 * it uses HeapAlloc, which has no special considerations and is GC'ed. If using ArenaAlloc,
 * it's important to recognize that references made to these data structures should
 * become invalid after the allocator is reset. Otherwise, this data will be overwritten
 * with new invalid geometrical data.
 * */
export let alloc: Alloc = new HeapAlloc();

export function geomGetAllocator() {
  return alloc;
}

export function geomSetAllocator(newAlloc: Alloc) {
  alloc = newAlloc;
}
